import React, { Component } from 'react'
import { BodyMovin, Loader } from '@drifthq/tide-core'
import BUILDER_ANIM from 'images/builder.json'

import './style.css'

export default class OnboardingPlaybookLoadingStep extends Component {
  componentDidMount = () => {
    setTimeout(() => this.props.onContinue(), 4000)
  }

  render() {
    const bodymovinOptions = {
      loop: false,
      autoplay: true,
      prerender: true,
      renderer: "svg",
      animationData: BUILDER_ANIM
    }

    return (
      <div className={'playbook-loading--root'}>
        <div className="playbook-loading--animation">
          <BodyMovin options={bodymovinOptions} />
        </div>
        <Loader className='playbook-loading--loader' />
        <span className='playbook-loading--description'>Building your bot...</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookLoadingStep/index.js